import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["optionA", "optionB"];

  propagateSelection(e) {
    const namedTarget = e.currentTarget.dataset.mentoredTarget;
    const hiddenWhenMentored = document.querySelectorAll(".js-hidden-when-mentored");
    const targets = this.targets
      .findAll(namedTarget)
      .filter((target) => target !== e.currentTarget); // imagine there's an inverse of filter

    targets.forEach((target) => {
      target.dispatchEvent(new Event("clonk", { bubbles: true }));
    });

    hiddenWhenMentored.forEach((element) => {
      element.classList.toggle("hidden");
    });
  }
}
